import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import FitterCourseSection from './pages/FitterCourseSection';
import ElectricianPage from './pages/ElectricianPage';
import About from './pages/About';
import PlacementPage from './pages/PlacementPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';

const App = () => {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About/>} />
          <Route path="/courses-fitter" element={<FitterCourseSection />} />
          <Route path="/gallery" element={<GalleryPage />} />
           <Route path="/courses-electrician" element={<ElectricianPage />} />
          <Route path="/placement" element={<PlacementPage />} />
          <Route path="/contact" element={<ContactPage />} /> 
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;